const colors = {
  dark: {
    default: '#1e1e2b',
    paper: '#424242',
    baseFontColor: '#cfd0d5',
    light24: 'hsla(0,0%,100%,.8)',
    light25: 'hsla(0,0%,100%,.6)',
    light26: 'hsla(0,0%,100%,.4)',
    buttonDark: '#27293d',
    buttonDarkHoverColor: '#434344',
    cardDark: '#202128',
    dark25: '#363848',
    dark15: '#2b3553',
    blue5: '#36529a',
    white100: '#fff',
    white90: '#fefefe',
    black100: '#000',
    primaryColor: '#ba54f5',
    warningColor: '#ff9800',
    dangerColor: '#f44336',
    successColor: '#42b883',
    infoColor: '#00acc1',
    roseColor: '#e91e63',
    grayColor: '#999999',
    pink: '#e14eca',
    orangePink: '#ff7683',
    homeColor: '#6b5cff'
  }
};

export default colors;
